// Utilidad para calcular costos basándose en la configuración guardada

// Configuración por defecto
const DEFAULT_CONFIG = {
  baseCost: 89.95,
  threshold: 100000,
  additionalCostPerUnit: 0.001
};

/**
 * Obtiene la configuración de costos desde localStorage
 * @returns {Object} Configuración de costos
 */
export const getCostConfig = () => {
  try {
    const savedConfig = localStorage.getItem('costConfig');
    if (savedConfig) {
      return JSON.parse(savedConfig);
    }
  } catch (error) {
    console.error('Error al cargar configuración de costos:', error);
  }
  return DEFAULT_CONFIG;
};

/**
 * Calcula el costo basándose en el número de envíos utilizados
 * @param {number} used - Número de envíos utilizados
 * @param {Object} config - Configuración de costos (opcional, se obtiene de localStorage si no se proporciona)
 * @returns {number} Costo calculado
 */
export const calculateCost = (used, config = null) => {
  const costConfig = config || getCostConfig();
  const { baseCost, threshold, additionalCostPerUnit } = costConfig;
  
  if (used <= threshold) {
    return (baseCost / threshold) * used;
  } else {
    return baseCost + ((used - threshold) * additionalCostPerUnit);
  }
};

/**
 * Formatea un valor de costo como moneda
 * @param {number} cost - Valor del costo
 * @param {string} currency - Símbolo de moneda (por defecto '$')
 * @returns {string} Costo formateado
 */
export const formatCost = (cost, currency = '$') => {
  return `${currency}${cost.toFixed(2)}`;
};

/**
 * Calcula y formatea el costo en una sola función
 * @param {number} used - Número de envíos utilizados
 * @param {Object} config - Configuración de costos (opcional)
 * @param {string} currency - Símbolo de moneda (por defecto '$')
 * @returns {string} Costo calculado y formateado
 */
export const calculateAndFormatCost = (used, config = null, currency = '$') => {
  const cost = calculateCost(used, config);
  return formatCost(cost, currency);
};

/**
 * Guarda la configuración de costos en localStorage
 * @param {Object} config - Configuración de costos a guardar
 * @returns {boolean} true si se guardó exitosamente, false en caso contrario
 */
export const saveCostConfig = (config) => {
  try {
    localStorage.setItem('costConfig', JSON.stringify(config));
    return true;
  } catch (error) {
    console.error('Error al guardar configuración de costos:', error);
    return false;
  }
};

/**
 * Restablece la configuración a los valores por defecto
 * @returns {boolean} true si se restableció exitosamente, false en caso contrario
 */
export const resetCostConfig = () => {
  return saveCostConfig(DEFAULT_CONFIG);
};

export default {
  getCostConfig,
  calculateCost,
  formatCost,
  calculateAndFormatCost,
  saveCostConfig,
  resetCostConfig,
  DEFAULT_CONFIG
};